import React, {Fragment} from 'react';
import css from './quote.module.scss';

export function Quote(props) {
  return (
    <div className={css.quote}>
      <blockquote className={css.text}>{props.children}</blockquote>
      <p className={css.author}>{props.author}</p>
    </div>
  );
}
